import { Box, Checkbox, CheckboxGroup, Flex, Stack } from "@chakra-ui/react";

const EmissionFilterComponent = ({ type, selectedValues, onChange }) => {
  const filterConfig = {
    dataQuality: {
      label: "Data Quality",
      options: [
        { value: "VERIFIED", label: "Verified" },
        { value: "UNVERIFIED", label: "Unverified" },
        { value: "MIXED", label: "Mixed" },
      ],
    },
    scope: {
      label: "Scope",
      options: [
        { value: "scope1", label: "Scope One" },
        { value: "scope2", label: "Scope Two" },
        { value: "scope3", label: "Scope Three" },
      ],
    },
  };

  const { label, options } = filterConfig[type];

  return (
    <Flex align="center" gap={4} mt={4}>
      <Box as="label" fontWeight="bold" fontSize="sm" color="gray.600">
        {label}:
      </Box>
      <CheckboxGroup value={selectedValues} onChange={onChange}>
        <Stack direction="row" spacing={4}>
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Stack>
      </CheckboxGroup>
    </Flex>
  );
};

export default EmissionFilterComponent;
